import React from 'react';
import FeatureFlagPlaceholder from 'components/ui/FeatureFlagPlaceholder';

export default function TokenTransfer() {
  return (
    <FeatureFlagPlaceholder
      title="Token Transfer"
      description="Regulated peer-to-peer token transfer with whitelist enforcement, compliance checks, and settlement confirmation will be available in Phase 2."
      phase="Phase 2"
    />
  );
}
